module.exports = __webpack_public_path__ + "static/media/thanos-static.cd80bdbf.png";